import axios from 'axios';
import interceptors from './interceptors';
import { apiUrl } from '../../config';

const CancelToken = axios.CancelToken;
let cancel;

export const http = axios.create({
    baseURL: apiUrl,
    withCredentials: true,
    credentials: 'include'
});

export const setCancelToken = function () {
    http.defaults.cancelToken = new CancelToken(function executor(c) {
        // An executor function receives a cancel function as a parameter
        cancel = c;
    });
};

setCancelToken();

export const cancelAll = function () {
    cancel('Requests cancelled by logout');
};

http.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

export default function install(Vue, { store, router }) {
    interceptors(http, store, router);
    Object.defineProperties(Vue.prototype, {
        $http: {
            get() {
                return http;
            }
        }
    });
}



// WEBPACK FOOTER //
// ./src/plugins/http/index.js